/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Wl_Success_DescInputs */

const en_st_wl_success_desc = /** @type {(inputs: St_Wl_Success_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We will email you the moment Studio opens.`)
};

const id_st_wl_success_desc = /** @type {(inputs: St_Wl_Success_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami kabari lewat email begitu Studio dibuka.`)
};

/**
* | output |
* | --- |
* | "We will email you the moment Studio opens." |
*
* @param {St_Wl_Success_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_wl_success_desc = /** @type {((inputs?: St_Wl_Success_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Wl_Success_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_wl_success_desc(inputs)
	return en_st_wl_success_desc(inputs)
});